var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "tile",
    { staticClass: "business-index", attrs: { link: "business-index" } },
    [
      _c(
        "tile-title",
        {
          attrs: { slot: "tileHeader", icon: "bar-chart" },
          slot: "tileHeader",
        },
        [_vm._v("Бизнес-коэффициенты")]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "business-index__content",
          attrs: { slot: "tileContent" },
          slot: "tileContent",
        },
        [
          _c(
            "app-transition",
            {
              attrs: {
                showLeftIf: _vm.contentType === "table",
                showRightIf: _vm.contentType === "chart",
              },
            },
            [
              _vm.data && _vm.years.length
                ? _c("business-index-table", {
                    attrs: {
                      slot: "left",
                      years: _vm.years.slice(-3),
                      targetObj: _vm.data,
                    },
                    slot: "left",
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.data && _vm.years.length
                ? _c("buisness-index-chart", {
                    attrs: {
                      slot: "right",
                      years: _vm.years,
                      targetObj: _vm.data,
                    },
                    slot: "right",
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c("business-index-modal", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isModal,
                expression: "isModal",
              },
            ],
            ref: "modal",
            attrs: {
              years: _vm.years,
              targetObj: _vm.data,
              title: _vm.title,
              printStyle: _vm.printStyle,
              htmlForPrint: _vm.htmlContent,
            },
            on: { close: _vm.closeModal },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "business-index__footer",
          attrs: { slot: "tileFooter" },
          slot: "tileFooter",
        },
        [
          _c(
            "div",
            { staticClass: "btn-container" },
            [
              _c(
                "tile-button",
                {
                  nativeOn: {
                    click: function ($event) {
                      return _vm.openModal.apply(null, arguments)
                    },
                  },
                },
                [_vm._v("Все показатели")]
              ),
              _vm._v(" "),
              _c(
                "app-switcher",
                {
                  attrs: {
                    leftClickHandler: _vm.toggle,
                    rightClickHandler: _vm.toggle,
                  },
                },
                [
                  _c(
                    "span",
                    { attrs: { slot: "leftValue" }, slot: "leftValue" },
                    [
                      _c("i", { staticClass: "uk-icon-bars" }),
                      _vm._v(" Таблица"),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    { attrs: { slot: "rightValue" }, slot: "rightValue" },
                    [
                      _c("i", { staticClass: "uk-icon-area-chart" }),
                      _vm._v(" График"),
                    ]
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("tile-print-pdf", {
            attrs: {
              html: _vm.htmlContent,
              printStyle: _vm.printStyle,
              title: _vm.title,
              filename: "businessIndex",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }